import { Button, Col, Text } from 'components';
import { Api } from 'lib';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ContentContainer } from 'screens/Admin/components';

const Events = (props) => {
  const [events, setEvents] = useState([]);
  const isMobile = useSelector((state) => state.appState.isMobile);
  const navigate = useNavigate();

  async function fetchEvents() {
    const res = await Api.get('/admin/getEvents');
    if (!res) return;

    setEvents(res);
  }

  async function removeEvent(id) {
    const res = await Api.post(`/admin/removeData`, { type: 'Event', id });

    if (!res) return alert('Something went wrong!');

    setEvents(events.filter((x) => x._id !== id));
  }

  return (
    <Col pad={!isMobile && '16px'} center>
      {!isMobile && (
        <Col>
          <Button icon="add" text="Add event" onClick={() => navigate('/admin/add-event')} />
        </Col>
      )}

      <ContentContainer>
        <Text className="header-text">Events</Text>

        <div className="container" />
      </ContentContainer>
    </Col>
  );
};

export default Events;
